import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ReservationService } from '../reservations.service';
@Component({
  selector: 'app-cancel-status',
  templateUrl: './cancel-status.component.html',
  styleUrls: ['./cancel-status.component.scss']
})
export class CancelStatusComponent implements OnInit {
  @Input() SO_Id;
  @Input() tripStatusId_input;
  @Input() tripCancelReasonId_input;
  @Input() modelDatePicker;
  @Output() cancelEmit: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() reloadSOGrid: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('selectStatusStandingOrder') private standingOrderStatus;
  private responseDataMsg = '';
  private tripstatusid_SO: any     = null;
  private tripcancelreasonid_SO: any     = null;
  private loadingMsg = false;
  private showCancelReasonMsg_SO = false;
  private isCancelReason_SO = false;
  private showResponseDataMsg = false;
  private soDisabledBtn = false;
  private cancelReasons_SO: any;
  private statusList: any;
  private status_openCancel: any     = [];
  constructor(
    protected serviceReservation: ReservationService,
    private sweetAlertHelper: SweetAlertHelper,
    ) {
    serviceReservation.getTripStatus().subscribe(
      data => {
        this.statusList = data;
        this.statusValidations();
      }
    );
    serviceReservation.getCancelReason().subscribe(
      data => {
        this.cancelReasons_SO = data;
      }
    );
  }

  ngOnInit() {
    this.tripstatusid_SO = this.tripStatusId_input;
    this.tripcancelreasonid_SO = this.tripCancelReasonId_input;
    this.onSelectStatus_SO_btn(this.tripStatusId_input);
  }

  statusValidations() {
    for ( let i = 0; i < this.statusList.length; i++) {
      if (this.statusList[i].tripstatusid === 1 || this.statusList[i].tripstatusid === 7) {
        this.status_openCancel.push(this.statusList[i]);
      }
    }
  }

  onSelectStatus_SO_btn(event) {
    this.showResponseDataMsg = false;
    if ( event === 7 ) {
      this.isCancelReason_SO = true;
    }else {
      this.isCancelReason_SO = false;
      this.tripcancelreasonid_SO = null;
    }
  }

  onClickSaveStatus_SO_event(event) {
    this.loadingMsg = true;
    this.soDisabledBtn = true;
    this.showResponseDataMsg = false;

    let startDate = null;
    let endDate = null;

    if(this.modelDatePicker){
      startDate =
        `${this.modelDatePicker.beginDate.year}-${this.modelDatePicker.beginDate.month}-${this.modelDatePicker.beginDate.day}`;
      endDate = `${this.modelDatePicker.endDate.year}-${this.modelDatePicker.endDate.month}-${this.modelDatePicker.endDate.day}`;
    }

    this.serviceReservation.changeStandingOrderStatus(this.SO_Id, this.tripcancelreasonid_SO, startDate, endDate)
      .subscribe(data => {
          this.onNotify_SO_status(data);
        },
        (error) => this.sweetAlertHelper.createCustomAlert({type: 'error', text: error.message})
      );
  }

  onClickSaveStatus_SO(event) {
    if(this.modelDatePicker) {
      this.sweetAlertHelper.createCustomAlert({
        title: "Are you sure you want to cancel this SO, with the trips in the Date Range Selected?",
        type: 'info',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Yes',
        cancelButtonColor: '#d33',
        cancelButtonText: 'No',
        showCancelButton: true,
        showLoaderOnConfirm: true
      }).then((opt) => {
        if (opt.value) {
          this.sweetAlertHelper.createCustomAlert({
            title: 'By accepting, you will cancel the Standing Order and the selected trips will be deleted permanent',
            type: 'info',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Yes, Accept',
            cancelButtonColor: '#d33',
            cancelButtonText: 'No, Cancel',
            showCancelButton: true,
            showLoaderOnConfirm: true
          }).then((opt) => {
            if (opt.value) {
              this.onClickSaveStatus_SO_event(event);
            }
          });
        }
      });
    }
    else{
      this.sweetAlertHelper.createCustomAlert({
        title: "Are you sure you want to cancel this SO?",
        type: 'info',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Yes',
        cancelButtonColor: '#d33',
        cancelButtonText: 'No',
        showCancelButton: true,
        showLoaderOnConfirm: true
      }).then((opt) => {
        if (opt.value) {
          this.onClickSaveStatus_SO_event(event);
        }
      });
    }
  }

  onNotify_SO_status(data) {
    if(data.success) {
      this.loadingMsg = false;
      this.soDisabledBtn = false;
      this.showResponseDataMsg = true;
      this.responseDataMsg = data.message;
      this.cancelEmit.emit();
      this.reloadSOGrid.emit();
    }
  }

  onSelectCancelOption_SO() {
    this.showCancelReasonMsg_SO = false;
  }

  onSelectedSO(statusId, cancelReasonId) {
    this.tripstatusid_SO = statusId;
    this.tripcancelreasonid_SO = cancelReasonId;
    this.onSelectStatus_SO_btn(statusId);
  }

  onClickCancel_SO(event) {
    this.cancelEmit.emit();
  }

  get disabledBtnSave(): boolean {
    return !this.tripcancelreasonid_SO || this.soDisabledBtn;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/cancel-status/cancel-status.component.ts